module.exports = __webpack_public_path__ + "media/assets/kyronlogo-2456001bb9b9e1a85a9168aacb37d13a.svg";